<template>
  <div id="app">
    <div class="contBox" v-if="this.$router.currentRoute.path !== '/loginRe'">
      <div class="loginBoxHearder">
        <div class="menuBox" @mouseenter="menuboxEnter" @mouseleave="menuboxLeave">
          <img class="titlelogo" src="./assets/titlelogo.png" />
          <el-menu default-active="myReceiveResume" router class="el-menu-demo" mode="horizontal"
            background-color="transparent" text-color="#ffffff" active-text-color="#ffffff">

            <el-menu-item index="myReceiveResume" v-if="!userStatus.adminToken">
              <span slot="title">收到的简历</span>
            </el-menu-item>
            <el-menu-item index="newPost" v-if="!userStatus.adminToken">
              <span slot="title">发布职位</span>
            </el-menu-item>
            <el-menu-item index="myPost" v-if="!userStatus.adminToken">
              <span slot="title">职位管理</span>
            </el-menu-item>
            <el-menu-item index="companylist" v-if="!userStatus.adminToken">
              <span slot="title">公司管理</span>
            </el-menu-item>
            <el-menu-item index="dhk" v-if="!userStatus.adminToken">
              <span slot="title">简历快</span>
            </el-menu-item>
            <el-menu-item index="gpt" v-if="!userStatus.adminToken">
              <span slot="title">AI招聘</span>
            </el-menu-item>
            <el-menu-item index="my" v-if="!userStatus.adminToken">
              <span slot="title">我的</span>
            </el-menu-item>
          </el-menu>
          <img class='avater' :src="userStatus.avatarPath" v-if="!userStatus.adminToken" />
          <img class='avater' :src="userStatus.companyLogo" v-if="userStatus.adminToken" />
        </div>

      </div>
      <router-view />
      <div class="kfbox" @click="openkef()" ><i class="el-icon-s-custom"></i><span>客</span><span>服</span></div>
      <el-dialog
        title="扫码添加客服微信"
        :visible.sync="dialogVisible2"
        width="30%"
        :before-close="handleClose">
        <img src="./assets/kf.jpg"  style="width: 70%;margin: 0 auto;display: block;"/>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible2 = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div v-if="this.$router.currentRoute.path === '/login'">
      <div class="contBox">
        <router-view />
      </div>
    </div>
    <div v-if="this.$router.currentRoute.path === '/loginRe'">
      <div class="contBox">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
!(function (t) {
  function e() {
    var e = this || self
      ; (e.globalThis = e), delete t.prototype._T_
  }
  'object' != typeof globalThis &&
    (this
      ? e()
      : (t.defineProperty(t.prototype, '_T_', {
        configurable: !0,
        get: e,
      }),
        _T_))
})(Object)

import moment, { now } from 'moment';


export default {
  name: 'app',
  components: {},
  data() {
    return {
      userStatus: this.$store.state.userStatus,
      isCollapse: true,
      dialogVisible2: false
    }
  },
  computed: {
    userStatusfunc() {
      return this.$store.state.userStatus
    },
  },
  watch: {
    userStatusfunc(val) {
      this.userStatus = val
    },
    $route(to, from) {
      if (!localStorage.getItem('token') && this.$route.path !== '/loginRe') {
        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
      } else if (this.userStatus.adminToken) {
      } else if (!this.userStatus.companyVo) {
        this.$notify({
          title: '提示',
          message: '您目前暂无所属公司，前往公司绑定',
          type: 'warning',
          duration: 1000,
        })
        this.$router.push({
          path: '/my',
        })
      } else if (to.path.indexOf('/login') > 0) {
        this.$router.push({
          path: '/myReceiveResume',
        })
      }
    },
  },
  created: function () {
    let nowtime = moment().format('YYYY-MM-DD')
    let logintime = localStorage.getItem('loginTime')
    if (nowtime !== logintime && this.$route.path !== '/loginRe') {
      localStorage.clear()
      this.$store.commit('setUser', {})
      window.location.href = 'https://www.pinkuaikuai.cn/login.html'
    } else {
      if (!localStorage.getItem('token') && this.$route.path !== '/loginRe') {
        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
      } else if (!localStorage.getItem('token') && this.$route.path === '/loginRe') {

      } else if (this.userStatus.adminToken) {
        this.$router.push({
          path: '/hrManagement',
        })
      } else if (!this.userStatus.adminToken) {
        if (this.$route.path === '/gpt') {

        } else {
          this.$router.push({
            path: '/myReceiveResume',
          })
        }
      } else if (!this.userStatus.companyVo) {
        this.$notify({
          title: '提示',
          message: '您目前暂无所属公司，前往公司绑定',
          type: 'warning',
          duration: 1000,
        })
        this.$router.push({
          path: '/my',
        })
      }
    }
  },
  methods: {
    menuboxEnter() {
      this.isCollapse = false
    },
    menuboxLeave() {
      this.isCollapse = true
    },
    openkef () {
      this.dialogVisible2 = true
    }
  },
  mounted: function () { },
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

#app {
  background-image: url('./assets/bg.png');
  background-attachment: fixed;
  background-size: 100% auto;
  min-height: 100vh;
  min-width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-x: hidden;

  .kfbox{
    background-color: #5DC2D0;
    position: fixed;
    right: 0;
    top: 70%;
    transform: translateY(-50%);
    font-size: 16px;
    color: #ffffff;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    padding: 20px 10px;
    cursor: pointer;
    border-radius: 5px;
  }

  .menuBox {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    .el-menu {
      border: none;
      border-radius: 8px;

      .el-menu-item {
        i {
          color: #ffffff;
        }
      }

      .is-active {
        background-color: transparent !important;

        i {
          color: #ffffff;
        }
      }
    }
  }

  .contBox {
    flex: 1;
    min-height: 100vh;
    // border-radius: 20px 20px 0 0;
    background-color: #ffffff;
    box-shadow: 0 0 15px rgba($color: #757575, $alpha: 0.75);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    position: relative;

    .loginBoxHearder {
      width: 100%;
      height: 123px;
      background-image: url('./assets/headerBg.png');
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .titlelogo {
        width: 216px;
        height: 67.8px;
        margin-left: 35.6px;
        margin-right: 132px;
      }
    }
  }

  .avater {
    border-radius: 100%;
    width: 65px;
    display: block;
    position: absolute;
    right: 46px;
    top: 29px;
  }

  ::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #fff;
  }

  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #fff;
  }

  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #fff;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #fff;
  }
}

input::-webkit-input-placeholder {
  color: '#5DC2D0';
}
</style>
